module.exports = __webpack_public_path__ + "static/img/icon-input-phone.a9a04ea7.png";